import React from 'react'
import Footer from '../../../components/Footer'
import ScienceImg from "../../../assets/images/environment.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';

const BSCEnvironmental = () => {
    return (
        <div className='  w-full relative font-poppins ' >
            <Title canonicalPath="/programmes/ug-courses/sciences/bsc/environmental-science" />
            <Title title="B.Sc. Environmental Science at Maya Devi University" description="Join the B.Sc. Environmental Science program at MDU, Dehradun. Gain essential knowledge to tackle environmental challenges and build a sustainable career." />
            <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
                <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>B.Sc. Environmental Sciences</h2>
                <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[60px] mt-5 justify-center md:justify-between ' >
                    <img src={ScienceImg} className=' md:w-[40%] rounded-lg ' />
                    <div className=' flex flex-col gap-4 ' >
                        <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
                        <p className=' text-justify md:text-md ' >The Department of Environmental Studies offers opportunities to develop interests in diverse  areas, including environmental science; public health; environmental values, policy, and law; earth system science; environmental monitoring; urban environmental problems; energy systems; climate change; environmental justice and our complex relations with both domesticated and wild nature.
                            <br /><br />
                            Department in Environmental Science is a part of School of Applied Sciences working as an interdisciplinary center to learn and disseminate the knowledge in various aspects of environment. The course curriculum is designed with the help of experts from academia and industries to train the manpower required for working in the field of environmental sciences.
                            <br /><br />
                            Department of Environmental Sciences is committed to provide an excellent educational and research experience that includes real life environmental problem solving, field and laboratory work.</p>
                        <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link>
                    </div>
                </div>

                <div className=' flex flex-col gap-10 mt-5 mb-[20px] ' >
                    <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>Intermediate / 10+2 or its equivalent examination from a recognized Board/ University/ MDU Entrance Examination</p>
                    </div>
                </div>

                <h4 className={` text-2xl font-semibold text-[#23376c] `}>B.Sc. Environmental Science (Hons. / Research)</h4>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <ul className=' list-disc ' >
                        <li>Acquired basic knowledge of different aspects of the environment and local, regional, and global environmental problems.</li>
                        <li>Developed environmental monitoring skills, including the conduct of experiments and data analysis.</li>
                        <li>Obtained exposure to the latest environmental pollution control technologies.</li>
                        <li>Acquired the knowledge and skills necessary for environmental design and management.</li>
                        <li>Acquired skills in the preparation, planning, and implementation of environmental projects.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <ul className=' list-disc ' >
                        <li>A degree in environmental science fosters young professionals towards innovative and independent career opportunities.One can work in jobs in conservation, sustainability, and environmental research and education.Opportunities for environmental science graduates can be found in the environmental science and wider biology sectors.The students after completing this  programme will have opportunity to take both industry as well as academics (pursue PhD programme) as their career choice. Several job opportunities are available in various sectors which include EIA consultancies, Environmental Labs,Industries, Pollution Control Boards and other government, non-government and private sectors.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <ul className=' list-disc ' >
                        <li>Environmental Consultant</li>
                        <li>Environmental Officer</li>
                        <li>Environmental Engineer</li>
                        <li>Conservation Scientist</li>
                        <li>Environmental Health Officer</li>
                        <li>Assistant Professor</li>
                        <li>Data Scientist</li>
                        <li>Research Analyst</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 mt-[20px] mb-[30px] ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>USPs</h4>
                    <ul className=' list-disc ' >
                        <li>State-of-the-art laboratories that are well-stocked and equipped with the latest technology.</li>
                        <li>CBCS and OBE model.</li>
                        <li>Advanced curriculum designed by Core Academia & Renowned Industry Experts.</li>
                        <li>Workshops and guest lectures for students, allowing them to engage and learn directly from industry professionals.</li>
                        <li>Hands-on learning opportunities, and commitment to interdisciplinary collaboration.</li>
                    </ul>
                </div>

                {/* table */}
                <div className="flex flex-col ">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead
                                        className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                                        <tr>
                                            <th scope="col" className=" px-6 py-4">Programme</th>
                                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Science</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Environmental Science </td>
                                            <td className="whitespace-nowrap  px-6 py-4">3</td>
                                            <td className="whitespace-nowrap  px-6 py-4">25</td>
                                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col mt-10 mb-5 ">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead
                                        className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                                        <tr>
                                            <th></th>
                                            <th scope="col" className=" px-6 py-4">SCHOLARSHIP PROGRAMS (Only One will be applicable)</th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                        <tr>
                                            <th scope="col" className=" px-6 py-4">Sr. No</th>
                                            <th scope="col" className=" px-6 py-4">Particulars</th>
                                            <th scope="col" className=" px-6 py-4">Category</th>
                                            <th>Percentage</th>
                                            <th>Applicable</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">1</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Single Girl Child</td>
                                            <td></td>
                                            <td className="whitespace-nowrap  px-6 py-4">10%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 " >2</td>
                                            <td className="whitespace-nowrap  px-6 py-4" rowSpan={4}>Merit Based</td>
                                            <td>75%-80%</td>
                                            <td className="whitespace-nowrap  px-6 py-4">20%</td>
                                            <td>*</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">3</td>
                                            <td className="whitespace-nowrap  px-6 py-4">80%-90%</td>
                                            <td className="whitespace-nowrap  px-6 py-4">30%</td>
                                            <td>*</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">4</td>
                                            <td className="whitespace-nowrap  px-6 py-4">90%-95%</td>
                                            <td className="whitespace-nowrap  px-6 py-4">50%</td>
                                            <td>*</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">5</td>
                                            <td className="whitespace-nowrap  px-6 py-4">95%-100%</td>
                                            <td className="whitespace-nowrap  px-6 py-4">70%</td>
                                            <td>*</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">6</td>
                                            <td className="whitespace-nowrap  px-6 py-4">For Hill States (J&K, Ladakh, Assam, Arunachal Pradesh, Manipur, <br />Mizoram, Meghalaya, Sikkim, Tripura, HP, Darjeeling, Kalimpong (West Bengal))</td>
                                            <td></td>
                                            <td className="whitespace-nowrap  px-6 py-4">15%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">7</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Martyrs/Defence Scholarship</td>
                                            <td></td>
                                            <td className="whitespace-nowrap  px-6 py-4">20%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 " >8</td>
                                            <td className="whitespace-nowrap  px-6 py-4" rowSpan={3}>Sport Quota Scholarship</td>
                                            <td>State</td>
                                            <td className="whitespace-nowrap  px-6 py-4">25%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 " >9</td>
                                            <td>National</td>
                                            <td className="whitespace-nowrap  px-6 py-4">35%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 " >10</td>
                                            <td>International</td>
                                            <td className="whitespace-nowrap  px-6 py-4">50%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">11</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Disabled Student Scholarship</td>
                                            <td></td>
                                            <td className="whitespace-nowrap  px-6 py-4">40%</td>
                                            <td>All Years</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">12</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Siblings Scholarship</td>
                                            <td></td>
                                            <td className="whitespace-nowrap  px-6 py-4">25%</td>
                                            <td>**</td>
                                        </tr>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 ">13</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Early Bird till 8th June</td>
                                            <td></td>
                                            <td className="whitespace-nowrap  px-6 py-4">40%</td>
                                            <td>*</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=' flex flex-col gap-10 mt-5 mb-[50px] ' >
                    <div className=' flex flex-col gap-2 items-center justify-center px-10 py-8 rounded-lg bg-[#23376c] ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Note</h4>
                        <p className=' text-white italic font-semibold ' > * From 2nd year scholarship will be offered only on 75% attendance in previous year with no back paper and no misconduct.</p>
                        <p className=' text-white font-semibold italic ' > ** applicable on those courses whose fees will be less compared to other siblings.</p>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}


export default BSCEnvironmental